var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoilerAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.106 3.5C21.106 4.32843 19.3052 5 17.0837 5C14.8622 5 13.0614 4.32843 13.0614 3.5C13.0614 2.67157 14.8622 2 17.0837 2C19.3052 2 21.106 2.67157 21.106 3.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0837 6.49997C18.3274 6.49997 19.5206 6.31453 20.4575 5.96513C20.7128 5.86993 20.9731 5.75372 21.2207 5.61084L21.997 19.892C22.0593 21.0373 21.1422 22 19.9888 22H14.1786C13.0252 22 12.1081 21.0373 12.1704 19.892L12.9466 5.61084C13.1943 5.75372 13.4546 5.86993 13.7099 5.96513C14.6468 6.31453 15.84 6.49997 17.0837 6.49997Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.01116 12H4.26255V10C4.26255 9.58579 4.60021 9.25 5.01674 9.25C5.43326 9.25 5.77092 9.58579 5.77092 10V12H8.28487V8C8.28487 7.58579 8.62253 7.25 9.03905 7.25C9.45558 7.25 9.79324 7.58579 9.79324 8V12H11.0888L10.6642 19.8111C10.62 20.6236 10.8575 21.3835 11.29 22H4.01116C2.90043 22 2 21.1046 2 20V14C2 12.8954 2.90043 12 4.01116 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoilerAlt);
export default __webpack_public_path__ + "static/media/boiler-alt.c07e986ca85fe3bc26dce16ec70d85ec.svg";
export { ForwardRef as ReactComponent };